export default function getUrl() {
  if (window?.location?.host === 'localhost:3000') {
    return {
      apiType: 'dev',
      faceRecognition: 'http://localhost:3100/',
      // faceRecognition: 'https://face-recognition-api.sistemasinteegra.com.br/',
      accreditation: 'https://credenciamento-api.sistemasinteegra.com.br/',
      // accreditation: 'http://localhost:3001/',
      externalBase: 'https://api-externa.inteegra.com.br/',
      // externalBase: 'https://api-externa.inteegratec.com.br/',
    }
  }

  return {
    apiType: 'inteegra',
    faceRecognition: 'https://face-recognition-api.sistemasinteegra.com.br/',
    accreditation: 'https://credenciamento-api.sistemasinteegra.com.br/',
    externalBase: 'https://api-externa.inteegra.com.br/',
  }
}
